
import { Box, Button, Typography, TypographyOwnProps, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { colors } from '../../../constants/colors';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import PaginationCustom from '../../../components/pagination/PaginationCustomTwo';
import { FrontApi, galleryListType } from '../../../api/front-api/front.api';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import StateComponents from '../../../components/state-component/StateComponents';
import SearchIcon from '@mui/icons-material/Search';
import { debouncedApiCall } from '../../../utils/app.utils';
import Hashids from 'hashids';
import { GALLERY_TYPE } from './enum/enum_gallery';
import { RootState } from '../../../store/store';
import { ImageContent } from '../../../assets/background/background';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';
import { useTranslation } from 'react-i18next';

type Props = {}


type boxContentProps = {
    title: string;
    detail: string;
    onViewAllClick?: () => void;
    data: { id: number, topic: string, img_src: string }[];
    variant?: TypographyOwnProps['variant'];
    hidden_view_all?: boolean;
    filter?: React.ReactNode;
    onClick?: (id_gallery: string) => void;
}
const getYouTubeEmbedId = (url: string): string | null => {
    const regExp = /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regExp);
    return match && match[1] ? match[1] : null;
};
export const getVideoPoster = (videoUrl: string): string => {
    // ถ้าเป็น YouTube ใช้ thumbnail
    const videoId = getYouTubeEmbedId(videoUrl);
    if (videoId) {
        return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    } else {
        return ImageContent.noImage
    }
};
const BoxContent: React.FC<boxContentProps> = ({ variant = 'h6', filter, onClick, hidden_view_all, title, detail, data, onViewAllClick }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    return (
        <Box className="px-4 md:px-20">
            <Typography sx={{ color: "#4A4A4A" }} fontWeight={700} variant={variant}>
                {title}
            </Typography>
            <Box py={2} className="flex justify-between gap-2 items-center">
                <Typography sx={{ fontSize: "14px", color: '#4A4A4A' }} variant='subtitle2'>
                    {detail}
                </Typography>
                {!hidden_view_all && (
                    <Button onClick={onViewAllClick} sx={{ color: colors.themeMainColor }} endIcon={<ArrowCircleRightIcon />}>
                        {t('HOME_PAGE_SEE_ALL')}
                    </Button>
                )}
            </Box>
            {filter}
            <Box sx={{
                display: 'grid',
                gap: "32px",
                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                [theme.breakpoints.down('md')]: {
                    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
                }
            }} className="">
                {data?.map((list, i) => {
                    return (
                        <Box onClick={() => onClick?.(String(list.id))} data-aos="zoom-in-left" key={list.id} className="cursor-pointer rounded-[8px] relative hover:opacity-85 overflow-hidden">
                            <Box height={147} className="relative">
                                <img className='object-cover hover:scale-125 transition-all duration-500' src={list?.img_src} alt={`img_${i}`} />
                            </Box>
                            {/* <Box className="absolute top-0 right-0">
                                <Checkbox {...label}
                                    icon={<IconButton><FavoriteIcon sx={{ color: "white" }} /></IconButton>}
                                    checkedIcon={<IconButton><Favorite sx={{ color: 'red' }} /></IconButton>} />
                            </Box> */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent pointer-events-none"></div>
                            <Box className="absolute w-full max-w-[90%] flex justify-center items-center h-[2.5rem] left-1/2 bottom-0 -translate-x-1/2">
                                <Typography textAlign={"center"} noWrap className="text-white">
                                    {list?.topic}
                                </Typography>
                            </Box>

                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}


const GalleryList: React.FC<Props> = ({ }: Props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const base_url = useSelector((state: RootState) => state.api.image_api);

    const GalleryTypes = searchParams.get('GALLERY_TYPE') as GALLERY_TYPE;

    const [type_select, set_type_select] = useState<GALLERY_TYPE>(GalleryTypes || GALLERY_TYPE.ALL);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, _setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [search, setSearch] = useState<string>("");
    const [data, setData] = useState<any[]>([]);

    const [pageVdo, setPageVdo] = useState<number>(1);
    const [pageLimitVdo, _setPageLimitVdo] = useState<number>(10);
    const [totalItemsVdo, setTotalItemsVdo] = useState<number>(0);
    const [searchVdo, setSearchVdo] = useState<string>("");
    const [dataVdo, setDataVdo] = useState<any[]>([]);
    const [gallery_type_data, set_gallery_type_data] = useState<any[]>([]);
    const [id_gallery_type, set_id_gallery_type] = useState<any>(null);


    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);

    const encodeId = (id_gallery: number, gallery_type: string) => {
        const id = hash_ids.encode(id_gallery);
        navigate(routeName.main.galleryDetail.replace(":id_gallery", id) + "?" + createQueryString('GALLERY_TYPE', gallery_type))
    }
    const createQueryString = useCallback(
        (name: string, value: string) => {
            const params = new URLSearchParams(searchParams.toString())
            params.set(name, value)

            return params.toString()
        },
        [searchParams]
    )



    const handleGetGalleryImage = useCallback(async (search?: string, id_gallery_type?: any) => {
        let query: galleryListType = {
            page: page,
            limit: pageLimit,
            type: GALLERY_TYPE.IMAGE
        }
        if (search) query.search = search;
        if (id_gallery_type) query.id_gallery_type = id_gallery_type?.id_gallery_type
        dispatch(setLoading());
        await FrontApi.galleryList(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                const totalItems = res.data?.data?.meta?.totalItems || 0;
                setData(response);
                setTotalItems(totalItems);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit])
    const handleGetGalleryType = async () => {
        await FrontApi.galleryTypeDropdown().then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                set_gallery_type_data(response)
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const handleGetGalleryVdo = useCallback(async (search?: string, id_gallery_type?: any) => {
        let query: galleryListType = {
            page: pageVdo,
            limit: pageLimitVdo,
            type: GALLERY_TYPE.VDO
        }
        if (searchVdo) query.search = search;
        if (id_gallery_type) query.id_gallery_type = id_gallery_type;
        dispatch(setLoading());
        await FrontApi.galleryList(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                const totalItems = res.data?.data?.meta?.totalItems || 0;
                setDataVdo(response);
                setTotalItemsVdo(totalItems)

            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [pageVdo, pageLimitVdo])

    useEffect(() => {
        handleGetGalleryType();
    }, [])
    useEffect(() => {
        handleGetGalleryImage();
    }, [handleGetGalleryImage])
    useEffect(() => {
        handleGetGalleryVdo();
    }, [handleGetGalleryVdo])

    return (
        <Box className="min-h-screen w-full md:max-w-[1136px] m-auto py-10 xl:py-20 xl:max-w-[1440px]">
            <Box className="flex flex-col gap-5">
                <Typography fontWeight={800} variant='h3' textAlign={"center"}>
                    {t("HOME_PAGE_IBSC_GALLERY")}
                </Typography>
                <Typography textAlign={"center"}>
                    {t("HOME_PAGE_A_COLLECTION_OF_PHOTOS_OF_ACTIVITIES,_ATMOSPHERE_AND_MEMORIES_OF_THE_INTERNATIONAL_BUDDHIST_COLLEGE_(IBSC).")}
                </Typography>
            </Box>

            <Box className="flex flex-col gap-20" py={5}>
                {[GALLERY_TYPE.IMAGE, GALLERY_TYPE.VDO].includes(type_select) && (
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "1",
                                name: t("HOME_PAGE_GALLERY"),
                                pathName: routeName.main.galleryList,
                                onClick: () => {
                                    set_type_select(GALLERY_TYPE.ALL);
                                    set_id_gallery_type(null);
                                },
                                disabled_match: true
                            },
                            {
                                key: "2",
                                name: type_select === GALLERY_TYPE.IMAGE ? t("HOME_PAGE_PHOTO") : t("HOME_PAGE_VIDEO"),
                                pathName: routeName.main.galleryList,
                            },
                        ]}
                    />
                )}
                {[GALLERY_TYPE.IMAGE, GALLERY_TYPE.ALL].includes(type_select) && (
                    <BoxContent
                        title={t("HOME_PAGE_PHOTOS")}
                        variant={GALLERY_TYPE.IMAGE === type_select ? 'h3' : undefined}
                        hidden_view_all={GALLERY_TYPE.IMAGE === type_select}
                        detail={t("HOME_PAGE_CAPTURE_IMPORTANT_MOMENTS,_CONVEY_IBSC'S_LIFE_AND_ACTIVITIES_THROUGH_A_STILL_IMAGE_PERSPECTIVE.")}
                        onViewAllClick={() => {
                            set_type_select(GALLERY_TYPE.IMAGE);
                            navigate(routeName.main.galleryList + "?" + createQueryString('GALLERY_TYPE', GALLERY_TYPE.IMAGE), {
                                replace: true
                            })
                        }}
                        onClick={(id_gallery) => {
                            encodeId(Number(id_gallery), GALLERY_TYPE.IMAGE);
                        }}
                        filter={GALLERY_TYPE.IMAGE === type_select ? (
                            <StateComponents
                                sxContainer={{ py: 2 }}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            md: 5
                                        },
                                        fieldProps: {
                                            startAdornment: <SearchIcon sx={{ mr: 2 }} />,
                                            placeholder: t("HOME_PAGE_SEARCH_NAME"),
                                            onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "AUTO-COMPLETE",
                                        gridProps: {
                                            xs: 12,
                                            md: 5
                                        },
                                        fieldProps: {
                                            getOptionLabel: (op) => op?.gallery_type_name || "",
                                            onChange: (_, val) => set_id_gallery_type(val ?? null),
                                            value: id_gallery_type || null,
                                            placeholder: t("HOME_PAGE_ALL_CATEGORIES"),
                                            labelId: "category",
                                            options: gallery_type_data || [],
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "COMPONENT",
                                        gridProps: {
                                            xs: 12,
                                            md: 2
                                        },
                                        fieldProps: {
                                            element: (
                                                <Box>
                                                    <Button onClick={() => handleGetGalleryImage(search, id_gallery_type)} startIcon={<SearchIcon />} color='success' variant='contained' sx={{ borderRadius: "8px" }}>{t("HOME_PAGE_SEARCH")}</Button>
                                                </Box>
                                            )
                                        }
                                    }
                                ]}
                            />
                        ) : undefined}
                        data={
                            data?.map((list) => {
                                const img_url = list?.media_file_path ? `${base_url}/${list?.media_file_path}${list?.media_file_name}` : ImageContent.noImage
                                return {
                                    id: list?.id_gallery,
                                    img_src: img_url,
                                    topic: list?.gallery_name || ""
                                }
                            })
                        }
                    />
                )}
                {[GALLERY_TYPE.VDO, GALLERY_TYPE.ALL].includes(type_select) && (
                    <BoxContent
                        title='วีดีโอ (Videos)'
                        variant={GALLERY_TYPE.VDO === type_select ? 'h3' : undefined}
                        hidden_view_all={GALLERY_TYPE.VDO === type_select}
                        detail={t("HOME_PAGE_THE_STORY_OF_IBSC_CONVEYED_THROUGH_ANIMATION_TO_SHARE_INSPIRATION_AND_IMPRESSIONS.")}
                        onViewAllClick={() => {
                            set_type_select(GALLERY_TYPE.VDO);
                            navigate(routeName.main.galleryList + "?" + createQueryString('GALLERY_TYPE', GALLERY_TYPE.VDO))
                        }}
                        onClick={(id_gallery) => {
                            encodeId(Number(id_gallery), GALLERY_TYPE.VDO);
                        }}
                        filter={GALLERY_TYPE.VDO === type_select ? (
                            <StateComponents
                                sxContainer={{ py: 2 }}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            md: 5
                                        },
                                        fieldProps: {
                                            startAdornment: <SearchIcon sx={{ mr: 2 }} />,
                                            placeholder: t("HOME_PAGE_SEARCH_NAME"),
                                            onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearchVdo }),
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "AUTO-COMPLETE",
                                        gridProps: {
                                            xs: 12,
                                            md: 5
                                        },
                                        fieldProps: {
                                            getOptionLabel: (op) => op?.gallery_type_name || "",
                                            onChange: (_, val) => set_id_gallery_type(val ?? null),
                                            value: id_gallery_type || null,
                                            placeholder: t("HOME_PAGE_ALL_CATEGORIES"),
                                            labelId: "category",
                                            options: gallery_type_data || [],
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "COMPONENT",
                                        gridProps: {
                                            xs: 12,
                                            md: 2
                                        },
                                        fieldProps: {
                                            element: (
                                                <Box>
                                                    <Button onClick={() => handleGetGalleryVdo(searchVdo, id_gallery_type)} startIcon={<SearchIcon />} color='success' variant='contained' sx={{ borderRadius: "8px" }}>{t("HOME_PAGE_SEARCH")}</Button>
                                                </Box>
                                            )
                                        }
                                    }
                                ]}
                            />
                        ) : undefined}
                        data={
                            dataVdo?.map((list) => {
                                const img_poster = getVideoPoster(list?.gallery_link || "")
                                // console.log(list?.gallery_link ,'list?.gallery_link ')
                                // console.log(img_poster,'img_poster')
                                return {
                                    id: list?.id_gallery,
                                    img_src: img_poster,
                                    topic: list?.gallery_name || ""
                                }
                            })
                        }
                    />
                )}

                {[GALLERY_TYPE.IMAGE].includes(type_select) && (
                    <PaginationCustom
                        page={page}
                        pageLimit={pageLimit}
                        setPage={(np) => setPage(np)}
                        totalItems={totalItems}
                    />
                )}

                {[GALLERY_TYPE.VDO].includes(type_select) && (
                    <PaginationCustom
                        page={pageVdo}
                        pageLimit={pageLimitVdo}
                        setPage={(np) => setPageVdo(np)}
                        totalItems={totalItemsVdo}
                    />
                )}
            </Box>
        </Box>
    )
}

export default GalleryList